import "moment/locale/id";
import { CurrencyFormat, formatDate, CountdownTimer, formatDate2, formatTime, formatDate3, formatTime2, formatTime3 } from "../../../components/helpers";
import moment from "moment";
import Count from "../../../components/helpers/count";

export const convertJemputGadai = (data) => {

    let converted = [];
    if (!data) return [];

    data.forEach((item, index) => {
        converted.push({
            key: index + 1,
            id: item?.id,
            req_jemput: formatDate(item?.gadai?.created_at),
            tanggal_jemput_submit: moment(item?.pick_up_date).toString(),
            tanggal_jemput: formatDate(item?.pick_up_date),
            tanggal_jemput_detail: formatDate2(item?.pick_up_date),
            tanggal_jemput_edit: formatDate3(item?.pick_up_date),
            waktu_jemput: formatTime(item?.pick_up_date),
            jam_jemput: formatTime2(item?.pick_up_date),
            menit_jemput: formatTime3(item?.pick_up_date),
            nama_nasabah: item?.gadai?.customer.ktp_name,
            no_telp: item?.gadai?.customer.phone_1,
            barang_jaminan: item?.gadai?.gadai_type,
            alamat: `${item?.address}`,
            lokasi_jemput: `${item?.address} ${item?.subdistrict} ${item?.city} ${item?.province}`,
            konfirmasi: <Count currentDate={item?.gadai.created_at} />,
            kode_gadai: item?.gadai_id,
            outlet_name: !item?.gadai?.outlet?.name ? "" : item?.gadai?.outlet.name,
            kode_kurir: !item?.employee_id ? "" : item?.employee_id,
            nama_kurir: `${item?.employee?.first_name} ${item?.employee?.last_name}`,
            gadai_picture: item?.gadai?.gadai_product_pictures,
        });
    });
    return converted;
};
